import React from 'react';

const Hero = () => {
  return (
    <section id="hero" className="min-h-screen bg-gradient-to-br from-slate-900 via-purple-900 to-slate-900 relative overflow-hidden">
      {/* Animated background elements */}
      <div className="absolute top-1/4 right-1/4 w-96 h-96 rounded-full bg-gradient-to-r from-purple-500/10 to-blue-500/10 blur-3xl animate-pulse"></div>
      <div className="absolute bottom-1/4 left-1/4 w-64 h-64 rounded-full bg-gradient-to-r from-blue-500/10 to-purple-500/10 blur-2xl animate-bounce"></div>
      
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 relative z-10">
        <div className="grid grid-cols-1 lg:grid-cols-2 gap-12 items-center min-h-screen py-20">
          {/* Left Column - Content */}
          <div className="flex flex-col justify-center space-y-8 animate-fade-in">
            {/* Badge */}
            <div className="inline-flex items-center px-4 py-2 bg-white/10 backdrop-blur-sm border border-white/20 rounded-full text-white text-sm font-medium w-fit">
              🚀 The Magic of AI for Real Estate
            </div>
            
            {/* Main Heading */}
            <h1 className="text-4xl sm:text-5xl lg:text-6xl font-bold text-white leading-tight">
              Stop Losing Leads Before the{' '}
              <span className="bg-gradient-to-r from-purple-400 to-blue-400 bg-clip-text text-transparent">
                Conversation Starts
              </span>
            </h1>
            
            {/* Description */}
            <p className="text-lg lg:text-xl text-gray-300 leading-relaxed max-w-2xl">
              We help agents go beyond listings: build online presence, run powerful ad campaigns, and engage every lead instantly via WhatsApp — all powered by AI.
            </p>
            
            {/* CTA Buttons */}
            <div className="flex flex-col sm:flex-row gap-4">
              <a 
                href="/login" 
                className="inline-flex items-center justify-center px-8 py-4 bg-gradient-to-r from-purple-600 to-blue-600 text-white font-semibold rounded-lg hover:from-purple-700 hover:to-blue-700 transform hover:scale-105 transition-all duration-200 shadow-lg hover:shadow-xl"
                onClick={() => console.log('event: cta_hero')}
              >
                Start Free – Launch Your First Campaign
                <svg className="ml-2 w-5 h-5" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                  <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M17 8l4 4m0 0l-4 4m4-4H3" />
                </svg>
              </a>
              
              <a 
                href="#demo" 
                className="inline-flex items-center justify-center px-8 py-4 bg-white/10 backdrop-blur-sm border border-white/20 text-white font-semibold rounded-lg hover:bg-white/20 transition-all duration-200"
              >
                Watch Demo
              </a>
            </div>
            
            {/* Trust indicators */}
            <p className="text-sm text-gray-400">
              No setup hassle. No shared leads. Built for Real Estate Pros.
            </p>
          </div>
          
          {/* Right Column - Visual */}
          <div className="flex items-center justify-center lg:justify-end">
            <div className="relative bg-white/10 backdrop-blur-sm rounded-2xl p-8 border border-white/20 shadow-2xl">
              <div className="w-full max-w-md">
                {/* Flow visualization */}
                <div className="space-y-6">
                  <div className="text-center text-white font-semibold mb-8">
                    Your Lead Generation Flow
                  </div>
                  
                  <div className="flex items-center justify-between">
                    <div className="bg-white rounded-lg p-4 shadow-lg flex-1 mx-2">
                      <div className="h-12 w-12 bg-gray-200 rounded-lg mb-3 mx-auto"></div>
                      <div className="h-3 w-16 bg-gray-300 rounded mx-auto mb-2"></div>
                      <div className="text-xs text-center text-gray-600">Property Listing</div>
                    </div>
                    
                    <div className="text-purple-400 text-2xl font-bold">→</div>
                    
                    <div className="bg-gradient-to-br from-purple-500 to-blue-500 text-white rounded-lg p-4 shadow-lg flex-1 mx-2">
                      <div className="h-12 w-12 bg-white/20 rounded-lg mb-3 mx-auto flex items-center justify-center">
                        🤖
                      </div>
                      <div className="text-xs text-center font-medium">AI Processing</div>
                    </div>
                    
                    <div className="text-purple-400 text-2xl font-bold">→</div>
                    
                    <div className="bg-green-500 text-white rounded-lg p-4 shadow-lg flex-1 mx-2">
                      <div className="h-12 w-12 bg-white/20 rounded-lg mb-3 mx-auto flex items-center justify-center">
                        💬
                      </div>
                      <div className="text-xs text-center font-medium">WhatsApp Lead</div>
                    </div>
                  </div>
                  
                  <div className="text-center text-gray-300 text-sm">
                    Listing → AI → Instant WhatsApp Engagement
                  </div>
                </div>
              </div>
              
              {/* Decorative elements */}
              <div className="absolute -bottom-4 -right-4 w-20 h-20 bg-gradient-to-br from-purple-500 to-blue-500 rounded-br-2xl opacity-50"></div>
              <div className="absolute -top-4 -left-4 w-16 h-16 bg-gradient-to-br from-blue-500 to-purple-500 rounded-tl-2xl opacity-30"></div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default Hero;